import "./Styles/Footer.css";

export default function Footer() {

    return (
        <>
           <footer className="footer content-center">
               <h2> <a href="https://www.linkedin.com/in/nakulsharma15" target="_blank">Made with love by Nakul Sharma</a></h2>
           </footer>
        </>
    );
}

